import styled from "@emotion/styled";
import tw from "tailwind.macro";

export const ProductList = styled.div`
    height: 80vh;
    ${tw` overflow-y-auto`};
`;
export const AddItemsTxt = styled.p`
    ${tw`text-center mt-40 text-yellow-500`};
`;
